import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ListView from './views/ListView';
import AthleteLIstView from './views/AthleteLIstView';
import BaseLayout from '../../components/CabinetBaseLayout';
import useApi from '../../api';

const Component = () => {
  const api = useApi();
  const router = api.router.contributions;
  return (
    <BaseLayout>
      <Switch>
        <Route exact path={router.list()} component={ListView} />
        <Route
          exact
          path={router.athleteList(':trainerId')}
          component={AthleteLIstView}
        />
      </Switch>
    </BaseLayout>
  );
};

export default Component;
